'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../styleInject.js');

var css_248z = ".Disclosure-module_header__UjM05{align-items:center;display:flex;justify-content:space-between}.Disclosure-module_body__9481S{padding:1rem 0}";
var styles = {"header":"Disclosure-module_header__UjM05","body":"Disclosure-module_body__9481S"};
styleInject["default"](css_248z, '9789093f-fec9-4d96-87ee-08dda34accff');

exports["default"] = styles;
